.ugc-textarea-wrap {
  position: relative;
  width: auto;
  height: 100%;
  user-select: none;

  textarea {
    display: block;
    width: 100%;
    padding: 16px 14px 0 14px;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    transition: all linear 80ms;
    background: none;
    outline: none;
    resize: none;
    &:hover {
      border: 1px solid var(--green-dark);
    }
  }

  textarea:disabled {
    cursor: not-allowed;
    border: solid 1px #a7b1bf;
    background-color: #f4f4f8;
    + label {
      cursor: not-allowed;
      background-color: #f4f4f8;
    }
  }

  &.active {
    label {
      color: #2c7500;
      margin-top: 0 !important;
      top: -10px !important;
      font-weight: normal !important;
      transform: scale(0.9);
    }
    textarea {
      border: 1px solid #2c7500;
    }
  }
  &.error {
    label {
      color: #bd3c37;
    }
    textarea {
      border: 1px solid #bd3c37;
    }
  }

  &.active.error {
    label {
      color: #bd3c37;
    }
    textarea {
      border: 2px solid #bd3c37;
    }
  }

  label {
    position: absolute;
    top: 26px;
    @at-root [dir='ltr'] & {
      left: 12px;
    }
    @at-root [dir='rtl'] & {
      right: 12px;
    }
    margin-top: -10px;
    height: 20px;
    line-height: 20px;
    padding: 0 4px;
    color: #aaa;
    background: #fff;
    border-radius: 4px;
    transition: all linear 80ms;
  }

  .active-label {
    margin-top: 0 !important;
    top: -10px !important;
    font-weight: normal !important;
    transform: scale(0.9);
  }
}
